import React from 'react';

import { ContentContainersCollection } from 'src/graphql/queries/GetFlexibleContentHub';
import {
  ImageContentBlock,
  MarketingContentBlock,
  MlNavtab,
  OrVideo,
  Resource,
  UiFloatingImageBlock,
  UiFullWidthImageBlock,
} from 'src/graphql/generated/graphql';
import { FullWidthImageBlock } from 'src/components/FullWidthImageBlock';

import VideoSection from './VideoSection';
import MarketingContentBlockSection from './MarketingContentBlockSection';
import ResourceSection from './ResourceSection';
import ImageContentBlockSection from './ImageContentBlockSection';
import TabsSection from './TabsSection';
import FloatingImageBlockSection from './FloatingImageBlockSection';

export type SupportedContentSectionTypes = MarketingContentBlock | ImageContentBlock | Resource | OrVideo | MlNavtab;

const ContentSection: React.FC<{
  contentBlock: NonNullable<ContentContainersCollection[0]>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  optionalProps?: any;
}> = ({ contentBlock, optionalProps }) => {
  if (!contentBlock) {
    return null;
  }

  switch (contentBlock.__typename) {
    case 'MarketingContentBlock':
      return (
        <MarketingContentBlockSection
          key={contentBlock.sys.id}
          contentBlock={contentBlock as MarketingContentBlock}
          {...optionalProps}
        />
      );
    case 'ImageContentBlock':
      return <ImageContentBlockSection key={contentBlock.sys.id} contentBlock={contentBlock as ImageContentBlock} />;
    case 'Resource':
      return <ResourceSection key={contentBlock.sys.id} resource={contentBlock as Resource} />;
    case 'OrVideo':
      return <VideoSection key={contentBlock.sys.id} video={contentBlock as unknown as OrVideo} />;
    case 'MlNavtab':
      return <TabsSection key={contentBlock.sys.id} tabs={contentBlock as MlNavtab} />;
    case 'UiFloatingImageBlock':
      return (
        <FloatingImageBlockSection key={contentBlock.sys.id} contentBlock={contentBlock as UiFloatingImageBlock} />
      );
    case 'UiFullWidthImageBlock':
      return <FullWidthImageBlock key={contentBlock.sys.id} contentBlock={contentBlock as UiFullWidthImageBlock} />;
    default:
      return null;
  }
};

export default ContentSection;
